function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useReducer, useEffect, useContext } from 'react';
export var TitleContext = createContext(undefined);
export var TitleNestContext = createContext(1);
function reducer(state, action) {
  switch (action.type) {
    case 'add':
      return state.concat({
        level: action.payload.level,
        title: action.payload.title
      }).filter(function (val, i, src) {
        return src.findIndex(function (title) {
          return title.level === val.level;
        }) === i;
      });
    case 'remove':
      return state.filter(function (title) {
        return title.level !== action.payload.level;
      });
    default:
      return state;
  }
}
function getTitle(arr) {
  return arr.slice(0).sort(function (a, b) {
    return b.level - a.level;
  }).map(function (_ref) {
    var title = _ref.title;
    return title;
  }).join(' | ');
}
export default function TitleProvider(_ref2) {
  var baseTitle = _ref2.baseTitle,
    children = _ref2.children;
  var level = useContext(TitleNestContext);
  var _useReducer = useReducer(reducer, [{
      level: level,
      title: baseTitle
    }]),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    title = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(function () {
    document.title = getTitle(title);
    return function () {
      document.title = baseTitle;
    };
  }, [title, baseTitle]);
  return /*#__PURE__*/React.createElement(TitleContext.Provider, {
    value: dispatch
  }, /*#__PURE__*/React.createElement(TitleNestContext.Provider, {
    value: level + 1
  }, children));
}